import React from 'react';
import { connect } from 'react-redux';
import { globalFieldLengths } from '@/constants/fields';
import { splitUrl } from '@/constants/urls';
import DictionaryUriInput from '../../dictionaries/components/DictionaryUriInput';
import DictionaryFieldContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/DictionaryFieldContainer';
import DictionaryFieldValue from './DictionaryFieldValue';

const DictionaryFieldUriTableCell = ({
  code,
  category,
  uri,
  uriProtocol,
  uriLink,
  dictionaryUUID,
  fieldUUID,
  isEditing,
  exists,
  canRead,
  canEdit,
  updateProperties,
  template,
}) => {
  const updateFieldUriLink = (value) => {
    updateProperties(category, code, dictionaryUUID, { uri: splitUrl(value, uriProtocol) }, fieldUUID, template);
  };

  const updateFieldUriProtocol = (value) => {
    updateProperties(category, code, dictionaryUUID, { uri: { protocol: value } }, fieldUUID, template);
  };

  if (!isEditing) {
    return (
      <DictionaryFieldValue
        category={category}
        code={code}
        value={uri}
        canRead={canRead}
        canEdit={canEdit}
        showUrlLinks
      />
    );
  }

  return (
    <DictionaryFieldContainer category={category} code={code} exists={exists} canRead={canRead} canEdit={canEdit}>
      <DictionaryUriInput
        type="field.uri"
        text={uriLink}
        protocol={uriProtocol}
        maxLength={globalFieldLengths.url}
        onChange={updateFieldUriLink}
        onProtocolChange={updateFieldUriProtocol}
      />
    </DictionaryFieldContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(DictionaryFieldUriTableCell);
